import React, { useState } from "react";
import { Form, Col, Row } from "react-bootstrap";
import ToolTip from "../../ToolTip/ToolTip";

function InputContainer({
  children,
  label,
  colSize,
  style,
  labelSize,
  onLabelClick = null,
  labelClassName,
  rowStyle,
  ignoreColPadding = false,
  required = false,
  stacked = false,
}) {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div style={{ ...style }}>
      <Form.Group
        as={Row}
        style={{
          alignItems: stacked ? "flex-start" : "center",
          flexDirection: stacked ? "column" : "row",
          marginBottom: "1.5rem",
          ...rowStyle,
        }}
      >
        {label && (
          <Form.Label
            className={`${labelClassName ?? "pl-4 d-flex"}`}
            column
            sm={"12"}
            md={stacked ? "12" : (labelSize || "2")}
            xs={"12"}
            style={{
              paddingTop: "0px",
              paddingRight: "0px",
              paddingBottom: stacked ? "2px" : "0px",
              wordBreak: "break-word",
              fontWeight: "600",
              cursor: `${onLabelClick ? "pointer" : "default"}`,
              color: onLabelClick && isHovered ? "#007bff" : undefined,
              textDecoration: onLabelClick && isHovered ? "underline" : undefined,
              transition: "color 0.15s, text-decoration 0.15s",
            }}
            onClick={onLabelClick}
            onMouseEnter={onLabelClick ? () => setIsHovered(true) : undefined}
            onMouseLeave={onLabelClick ? () => setIsHovered(false) : undefined}
          >
            {onLabelClick ? (
              <ToolTip message="Crear nuevo" placement="top">
                <span>
                  {label}
                  {required && (
                    <span style={{ color: "red", marginLeft: "4px", fontWeight: "bold" }}>
                      *
                    </span>
                  )}
                </span>
              </ToolTip>
            ) : (
              <>
                {label}
                {required && (
                  <span style={{ color: "red", marginLeft: "4px", fontWeight: "bold" }}>
                    *
                  </span>
                )}
              </>
            )}
          </Form.Label>
        )}
        {!ignoreColPadding ? (
          <Col sm={"12"} md={stacked ? "12" : (colSize || "8")} xs={"12"} className="pr-10">
            {children}
          </Col>
        ) : (
          children
        )}
      </Form.Group>
    </div>
  );
}

export default InputContainer;
